export const CLIENTDETAILS = "CLIENTDETAILS_GROUPS";
export const CLIENTDETAILS_ERROR = "CLIENTDETAILS_ERROR";
export const CLIENTDETAILS_HIDE_ERROR = "CLIENTDETAILS_HIDE_ERROR";
export const CLIENTDETAILS_START_LOADER = "CLIENTDETAILS_START_LOADER";
export const CLIENTDETAILS_STOP_LOADER = "CLIENTDETAILS_STOP_LOADER";
